angular.module('qkr').factory('legacyService', ($http, appConfig) => ({
		
		loadOtherQkrConfig() {
			return $http.get(appConfig.apiUrl + 'legacyConfig/getLegacyOptionsConfiguration', {withCredentials: true})
				.then((response) => response.data);
		},
		
		loadStickerSheetConfig() {
			return $http.get(appConfig.apiUrl + 'legacyConfig/getStickerSheetConfiguration', {withCredentials: true})
				.then((response) => response.data);
		},

		updateGeneralConfiguration(form) {
			return $http.post(appConfig.apiUrl + 'legacyConfig/updateLegacyOptionsConfiguration', form);
        },
        
         updateStickerConfiguration(form) {
         	return $http.post(appConfig.apiUrl + 'legacyConfig/updateStickerConfiguration', form);
        }

	}));



// WEBPACK FOOTER //
// ./src/services/legacy.services.js